<template>
  <div>
    <h1 class="md-title pt-4">Responses</h1>
    <v-sheet v-for="response in responses" :key="response.id">
      <base-learning-response-edit
        :manager="manager"
        :response="response"
        :showDelete="showDelete"
        :showAdd="showAdd"
      >
      </base-learning-response-edit>
    </v-sheet>
    <v-row class="pt-6">
      <v-col class="col-9 pl-8">
        <v-text-field
          ref="keyInput"
          id="js-new-response-input"
          outlined
          single-line
          dense
          v-model="responseKey"
          :rules="textFieldRules"
          @keyup.enter="addResponseWithKey()"
        ></v-text-field>
      </v-col>
      <v-col class="col-3 pr-4">
        <v-btn class="default-action-btn" @click="addResponseWithKey()"
          >Add Response</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import BaseLearningResponseEdit from "@/components/BaseLearningResponseEdit"
import validationMixin from "@/mixins/validationMixin"

export default {
  mixins: [eventMixin, validationMixin],
  components: { BaseLearningResponseEdit },
  data() {
    return {
      responseKey: ""
    }
  },
  props: {
    itemId: { type: Number },
    manager: { type: Boolean, default: true },
    responses: { type: Array, default: [] },
    showAdd: { type: Boolean, default: true },
    showDelete: { type: Boolean, default: true }
  },
  methods: {
    addResponseWithKey() {
      if (this.$refs.keyInput.validate()) {
        let key = this.responseKey

        this.fireEvent("learningResponse:add", {
          itemId: this.itemId,
          key: key
        })

        this.$refs.keyInput.reset()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";
</style>
